import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import StronglyDisagree from '../assets/img-face-angry.png'
import Disagree from '../assets/img-face-sad.png'
import Neither from '../assets/img-face-neutral.png'
import Agree from '../assets/img-face-happy.png'
import StronglyAgree from '../assets/img-face-joyful.png'
import { QuestionHeader, QuestionHead} from '../styled/styles';

const StyledDiv = styled.div`
  display: ${props => props.toDisplay ? 'block' : 'none'};
`;

const Card = styled.div`
  background-color: ${props => props.selected ? '#D9EEF7' : '#FFF'};
  color: #555;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  padding: 10px;
  margin-right: 5px;
  margin-top: 5px;
  border: ${props => props.selected ? '1px solid #00AEEF' : '1px solid transparent'};
  &:hover {
    border-color: #00AEEF;
    color: #00AEEF;
  }
  display: flex; 
  flex-direction: column; 
  text-align: center;
  font-size: 11.0683px;
  width: 100%;

  @media (max-width: 350px) {
    width: 19%;
  }
`;

const CardDiv = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0 15px;

  @media (max-width: 350px) {
    width: 55%;
  }
`

const Rating = ({ currentPage, errors, setErrors, toDisplay, question, answeredQuestions, setAnsweredQuestions, currentPageAnswers, setCurrentPageAnswers }) => {
   
  const [selectedState, setSelectedState] = useState('');

  useEffect(() => {
    if (currentPageAnswers.length && !currentPageAnswers.every(currentAnswer => answeredQuestions[currentPage - 1]?.includes(currentAnswer))) {
      let answeredQuestionsCopy = [...answeredQuestions]
      answeredQuestionsCopy[currentPage - 1] = currentPageAnswers
      setAnsweredQuestions(answeredQuestionsCopy)
    }
  },[])

  useEffect(() => {
       
    if (!toDisplay) {
      setSelectedState('')

      let answeredQuestionsCopy = [...answeredQuestions]
       
      answeredQuestionsCopy[currentPage - 1] = answeredQuestionsCopy[currentPage - 1]?.filter(answers => !answers.includes(question.Answers[0].AnswerCode))
      setAnsweredQuestions(answeredQuestionsCopy)
      setCurrentPageAnswers(currentPageAnswers.filter(answers => !answers.includes(question.Answers[0].AnswerCode)))
    }
  },[toDisplay])

  const handleCardclick = (event, answerExpression) => {
    setSelectedState(answerExpression)

    let answeredQuestionsCopy = [...answeredQuestions]
    answeredQuestionsCopy[currentPage - 1] = [...answeredQuestionsCopy[currentPage - 1]?.filter(answer => answerExpression.split('=')[0] !== answer.split('=')[0]), answerExpression]

    setAnsweredQuestions(answeredQuestionsCopy)
    setCurrentPageAnswers([...currentPageAnswers.filter(answerCode => !answerCode.includes(answerExpression.split('=')[0])), answerExpression])

          
      
    setErrors(errors.filter(errorExpression => errorExpression !== event.target.dataset.code))
  }

  if (toDisplay) {
    window.shown++
  }

  return (
    <>
        <QuestionHead padding="0 15px">{question.QuestionHead}</QuestionHead>
        <QuestionHeader padding="0 15px"question={question} errors={errors} setErrors={setErrors}>{question.QuestionName.replace(/<\/?[^>]+(>|$)/g, "")}</QuestionHeader>

        <StyledDiv toDisplay={toDisplay}>

        <CardDiv>
            {question.Answers.map((answer, i) => (
            <Card
                key={answer.Expression}
                id={answer.Expression}
                value={answer.Expression}
                data-code={question.QuestionCode}
                selected={currentPageAnswers.length ? currentPageAnswers.includes(answer.Expression) : selectedState === answer.Expression}
                onClick={(e) => handleCardclick(e, answer.Expression)}
            >
                <img data-code={question.QuestionCode} style={{width: '40px', height: '40px'}} src={i === 0 ? StronglyDisagree : i === 1 ? Disagree : i === 2 ? Neither : i === 3 ? Agree : StronglyAgree} />
                {answer.AnswerLabel}
            </Card>
            ))}
        </CardDiv>

        </StyledDiv>
    </>
  );
};

export default Rating;